var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcReceipt = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "lsl0gcox8a",
    d: "M15 14.167H5V12.5h10v1.667zm0-3.334H5V9.167h10v1.666zM15 7.5H5V5.833h10V7.5zM2.5 18.333l1.25-1.25L5 18.333l1.25-1.25 1.25 1.25 1.25-1.25 1.25 1.25 1.25-1.25 1.25 1.25 1.25-1.25 1.25 1.25 1.25-1.25 1.25 1.25V1.667l-1.25 1.25L15 1.667l-1.25 1.25-1.25-1.25-1.25 1.25L10 1.667l-1.25 1.25-1.25-1.25-1.25 1.25L5 1.667l-1.25 1.25-1.25-1.25v16.666z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "wrwo1l2nob",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lsl0gcox8a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#2565C7",
    mask: "url(#wrwo1l2nob)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H41.667V41.667H0z",
    transform: "translate(-10.833 -10.833)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcReceipt, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-receipt.88f9cc8b.svg";
export { ForwardRef as ReactComponent };